/**
 * Created by iamso on 17.12.2021
 */

const FeastExpeditionLogic = function (mission) {
    this.mission = mission;

    if (mission.isRunning()) {
        cleverapps.eventBus.on("mapEvent", this.onMapEvent.bind(this), this);
    }
};

FeastExpeditionLogic.prototype.destructor = function () {
    runCleaners(this);
};

FeastExpeditionLogic.prototype.onMapEvent = function (type, options) {
    if (!MissionManager.hasProperLocation(this.mission.type)) {
        return;
    }
    let points = 0, sourceUnit, delay, time;

    if (Mission.GetMissionType(this.mission.type) === Mission.TYPE_SNAIL_FEAST) {
        if (type === Map2d.SPAWN && ["drsnail", "seasnail"].indexOf(options.unit.code) !== -1) {
            points = this.getSnailPoints(options.unit.stage);
            if (options.affected && Unit.IsApplicable({ type: "snailhouse" }, options.affected)) {
                sourceUnit = options.affected;
            } else {
                sourceUnit = options.unit;
            }
        }
    } else {
        switch (type) {
            case Map2d.RUDOLF_COMPLETED:
                points = options.points;
                sourceUnit = options.unit;
                break;
            case Map2d.COMPLETE_MINING:
                sourceUnit = options.unit;
                time = options.task.time;
                break;
            case Map2d.BUILD:
                sourceUnit = options.affected;
                time = options.time;
                break;
            case Map2d.SPAWN:
                if (Array.isArray(options.affected) && options.unit.isBuilt()) {
                    sourceUnit = options.unit;
                    const hasOtherPrizes = options.unit.getData().createPrize !== undefined;
                    delay = hasOtherPrizes ? 500 : 0;

                    const sourceStage = options.unit.stage - 1;

                    if (sourceStage >= 6) {
                        points = PseudoRandom.GET().random(10, 13);
                    } else if (sourceStage === 5) {
                        points = PseudoRandom.GET().random(8, 11);
                    } else if (sourceStage === 4) {
                        points = PseudoRandom.GET().random(6, 9);
                    } else if (sourceStage === 3) {
                        points = PseudoRandom.GET().random(4, 7);
                    } else if (sourceStage === 2) {
                        points = PseudoRandom.GET().random(2, 5);
                    } else if (sourceStage === 1) {
                        points = PseudoRandom.GET().random(1, 3);
                    } else if (sourceStage === 0) {
                        points = 1;
                    }
                }
                break;
        }

        if (time) {
            if (time >= cleverapps.parseInterval("60 minutes")) {
                points = 3;
            } else if (time >= cleverapps.parseInterval("10 minutes")) {
                points = 2;
            } else {
                points = 1;
            }
        }
    }

    if (points > 0 && sourceUnit) {
        this.collectFromUnit(points, sourceUnit, delay);
    }
};

FeastExpeditionLogic.prototype.getSnailPoints = function (stage) {
    if (!this.snailPoints) {
        this.snailPoints = {};
    }

    if (this.snailPoints[stage]) {
        return this.snailPoints[stage];
    }

    let points;
    if (stage === 0) {
        points = 0;
    } else if (stage === 1) {
        points = 1;
    } else if (stage === 2) {
        points = 3;
    } else {
        points = Math.round(this.getSnailPoints(stage - 1) * 2.5);
        if (points % 5 > 2.5) {
            points = points - points % 5 + 5;
        } else {
            points -= points % 5;
        }
    }

    this.snailPoints[stage] = points;

    return points;
};

FeastExpeditionLogic.prototype.collectFromUnit = function (amount, unit, delay) {
    Map2dLocation.currentLocation.addReward("mission", {
        missionType: this.mission.type,
        amount
    }, unit, {
        delay: delay || 0
    });
};

FeastExpeditionLogic.prototype.beforeRemove = function (f) {
    if (Mission.GetMissionType(this.mission.type) === Mission.TYPE_SNAIL_FEAST && !cleverapps.gameModes.multipleHeroes) {
        let unitsToReplace = "drsnail";
        let newCode = "drresource";
        if (["undersea2", "undersea3"].indexOf(this.mission.location) !== -1) {
            unitsToReplace = "seasnail";
            newCode = "searesource";
        }
        Map2dLocation.currentLocation.replaceUnit({ code: unitsToReplace }, (unit) => {
            const codes = cleverapps.unitsLibrary.listAvailableByType(newCode);
            const code = PseudoRandom.GET().choose(codes);
            return {
                code,
                stage: Math.min(3, unit.stage, Families[code].units.length - 1)
            };
        });
    }

    f();
};
